export const FETCH_MY_OPUSES = "FETCH_MY_OPUSES";
export const fetchMyOpusesAction = (opuses) => {
  return {
    type: "FETCH_MY_OPUSES",
    payload: opuses,
  };
};
export const FETCH_SELECTED_OPUS = "FETCH_SELECTED_OPUS";
export const fetchSelectedOpusAction = (opuses) => {
  return {
    type: "FETCH_SELECTED_OPUS",
    payload: opuses,
  };
};

export const INIT_MY_OPUSES = "INIT_MY_OPUSES";
export const initMyOpusesAction = () => {
  return {
    type: "INIT_MY_OPUSES",
    payload: null,
  };
};

export const DELETE_OPUS = "DELETE_OPUS";
export const deleteOpusAction = (opuses) => {
  return {
    type: "DELETE_OPUS",
    payload: opuses,
  };
};

export const SLECTED_OPUS = "SLECTED_OPUS";
export const selectedOpusAction = (opus) => {
  return {
    type: "SLECTED_OPUS",
    payload: opus,
  };
};
